import { render, staticRenderFns } from "./Returning.vue?vue&type=template&id=57fd95cd&"
import script from "./Returning.vue?vue&type=script&lang=js&"
export * from "./Returning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports